export const ifExistCall = (func, ...args) => func && func(...args,)
